import React, {useMemo} from 'react';
import {useProjectFormMailReportsByEstablishedYearRangeQuery} from 'api';
import {useParams} from 'react-router-dom';
import Table from '../Table';

export default () => {
  const {projectId} = useParams<{projectId: string}>();
  const {data: {projectFormMailReportsByEstablishedYearRange = []} = {}} =
    useProjectFormMailReportsByEstablishedYearRangeQuery({
      variables: {uuid: projectId},
      fetchPolicy: 'cache-and-network',
    });

  const data: any = useMemo(
    () =>
      projectFormMailReportsByEstablishedYearRange.map((report) => {
        return {
          name: report.establishedYearRange,
          mailCount: report.mailCount,
          clickCount: report.clickCount,
          clickRate: report.clickRate,
          replyCount: report.replyCount,
          replyRate: report.replyRate,
          appointCount: report.appointCount,
          appointRate: report.appointRate,
        };
      }),
    [projectFormMailReportsByEstablishedYearRange],
  );

  return <Table data={data} />;
};
